import { ConfederationsEnum, EnumSection, MatchOrderCategoriesEnum, OrderCategoriesEnum, OrderMatchCompetition } from '../interfaces/clientInterfaces';
import { IStore } from '../interfaces';
import { ISelectItem } from './components/Select/Select';

export const ALL_COUNTRIES_NAME = 'all';
export const MATCH_NAME = 'Matches';
export const REAL_MADRID_NAME = 'Real Madrid';
export const REAL_MADRID = 'real_madrid';
export const SELECT_BY_COUNTRIES = 'selectByCountry';
export const SELECT_BY_COUNTRIES_NAME = 'Select by country';
export const MATCH_LINK = 'games';
export const SELECTED_COUNTRIES = 'SelectedCountries';
export const COMPETITION_LINK = 'competitions';
export const COMPETITION_NAME = 'Select by competitions';

export const ALPHABETICALLY_ORDER_KEY = 'Alphabetically';
export const POP_ORDER_KEY = 'Population';
export const STADIUM_ORDER_KEY = 'Stadium capacity';
export const YEAR_ORDER_KEY = 'Foundation (oldest)';
export const CATEGORY_ORDER_KEY = 'Category';
export const HONOURS_ORDER_KEY = 'Honours/Titles';
export const NUMBER_HONOURS_ORDER_KEY = 'Number of titles';
export const SEASONS_TOP_ORDER_KEY = 'Seasons in top category';

export const CHRONO_ORDER_KEY = 'Chronologically';
export const COMPETITION_ORDER_KEY = 'Competition';
export const ROUND_ORDER_KEY = 'Round';

export const PAGE_KEY = 'Page: ';
export const ITEMS_PER_PAGE = 'Items/page:';
export const SORT_TITLE_KEY = 'Sort by:';
export const ASCENDING_KEY = 'Ascending';
export const DESCENDING_KEY = 'Descending';

export const SHOW_MAP_KEY = 'Show on map';
export const SHOW_MAP_STADIUM_KEY = 'See stadium on map';

export const FILTER_MATCHES_TOOLTIP = 'Filter scarves from matches';
export const FILTER_TEAMS_TOOLTIP = 'Filter scarves from teams';

export const ITEMS_PER_PAGE_ITEMS: ISelectItem[] = [
	{
		text: '10 teams/page',
		id: '10'
	},
	{
		text: '20 teams/page',
		id: '20'
	},
	{
		text: '50 teams/page',
		id: '50'
	}
]

export const matchCompetitionDefault = [
	OrderMatchCompetition.ucl,
];

export const initialConfederations = [
	ConfederationsEnum.eu,
	ConfederationsEnum.sa,
	ConfederationsEnum.na,
	ConfederationsEnum.af,
	ConfederationsEnum.as
];

export const initialState: IStore = {
	initialized: false,
	scarves: {
		scarves: [],
		scarvesByTeamMap: {},
		lastScarves: [],
		currentGroupScarves: [],
	},
	teams: {
		teams: [],
		teamsById: {},
		teamsByCountryCode: {},
	},
	matches: {
		currentMatchScarfGroups: [],
		matchScarfGroups: [],
		currentRMMatchScarfGroups: [],
		rMMatchScarfGroups: []
	},
	competitions: {
		competitionsWithEvolution: {},
		competitionsDictionary: {},
		evolutions: {},
		availableCompetitions: [],
		selectedCompetitions: {},
		selectedEvolutions: []
	},
	general: {
		countryCodes: [],
		homeDetailScarfInfo: null,
	},
	map: {
		stadiumCluster: {},
		teamStadiumCoordinatesMap: new Map<string, number[]>(),
	},
	orderAndPaging: {
		orderBy: {
			category: OrderCategoriesEnum.honours,
			ascending: false,
			confederations: initialConfederations,
			matchCompetition: matchCompetitionDefault,
			matchCategory: [MatchOrderCategoriesEnum.chronologically, MatchOrderCategoriesEnum.competition],
			matchAscending: false,
			countryCodes: {},
			orderByRegion: '',
			orderBySubregion: ''

		},
		allPagingInfo: {
			currentPage: 0,
			totalPages: 0,
			teamsPerPage: 10
		}
	},
	ui: {
		section: EnumSection.home,
		currentCountry: '',
		showTreeMap: false,
		viewPort: {
			width: 2000,
			height: 1000
		},
		isMobileViewActive: false,
		trophyTooltip: null,
		isReducedView: false,
		areTeamHonoursVisible: false,
		detailTrophyTooltip: null,
		reserveTeamTooltip: null
	},
	sideTree: {
		matchesSideEntries: [],
		teamSideEntries: [],
		sideTreeEntries: []
	},
};
